<template>
  <div>
    <template v-if="loading">
      <div class="preloader" style="display: flex;flex-direction: column;">
        <img src="/assets/images/logo.svg">
        <h2 class="text-white">Integrated Platform</h2>

        <div class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <section class="dashboard">
        <div class="bg-gradient-primary border-bottom-white py-32pt">
          <div
            class="container d-flex flex-column flex-md-row align-items-center text-center text-md-left"
          >
            <img
              src="/assets/images/illustration/student/128/white.svg"
              width="104"
              class="mr-md-32pt mb-32pt mb-md-0"
              alt="student"
            >
            <div class="flex mb-32pt mb-md-0">
              <h2 class="text-white mb-0">{{userData.fname +" " + userData.lname}}</h2>
              <p class="lead text-white-50 d-flex align-items-center">N-power Beneficiary</p>
            </div>

            <router-link
              class="btn btn-outline-white"
              active-class="active"
              :to="{name: 'user-profile', params: {id}}"
              exact
            >
              <i class="material-icons">account_circle</i>
              Edit Profile
            </router-link>
          </div>
        </div>

        <div class="page-section bg-white border-bottom-2">
          <div class="container page__container">
            <template v-if="classesLoaded && classes.length">
              <div>
                <div v-for="classItem in classes" :key="classItem.id">
                  <div class="card">
                    <img :src="classItem.avatar" :alt="classItem.title" class="card-img">
                    <div class="fullbleed bg-primary" style="opacity: .25;"></div>
                    <div
                      class="card-body d-flex align-items-center justify-content-center fullbleed"
                    >
                      <div>
                        <h2 class="text-white mb-16pt text-center">{{classItem.title}}</h2>
                        <!--<div class="d-flex align-items-center mb-16pt justify-content-center">-->
                        <!--&lt;!&ndash;<div class="d-flex align-items-center">&ndash;&gt;-->
                        <!--&lt;!&ndash;<span class="material-icons icon-16pt text-white mr-4pt">play_circle_outline</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;<p class="flex text-white lh-1"> lessons</p>&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                        <!--</div>-->

                        <div class="d-flex align-items-center mb-16pt justify-content-center">
                          <div class="d-flex align-items-center">
                            <p class="flex text-white lh-1" v-html="classItem.description"></p>
                          </div>
                        </div>

                        <div
                          class="d-flex align-items-center justify-content-center"
                          style="margin-top:25px "
                        >
                          <router-link
                            v-if="isJoined(classItem.id) === 'Resume Learning'"
                            :to="{
                                                    name: 'course-detail',
                                                    params: { id: classItem.id }}"
                          >
                            <button class="btn btn-outline-white ml-0">{{ isJoined(classItem.id) }}</button>
                          </router-link>
                          <button
                            v-else
                            @click="joinCourse(classItem.id)"
                            class="btn btn-outline-white ml-0"
                          >{{ isJoined(classItem.id) }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="features__footer">
                <Pagination v-if="total > limit" :options="{ limit, offset, total, baseUrl }"/>
              </div>
            </template>
            <template v-else-if="classesLoaded">
              <br>
              <div class="alert alert-warning center" role="alert">
                <strong>Warning!</strong> No course available for your career choice.
              </div>
            </template>
            <template v-else>Error loading courses</template>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../components/Loader";
import { getUserProfile } from "../../utils/api/user";
import { mapGetters, mapMutations } from "vuex";
import { joinCourse, getFilteredCourses } from "../../utils/api/course";
import { success, fail } from "../../utils/toast";
import { setTimeout } from "timers";
import Pagination from "../../components/Pagination";

export default {
  name: "UserDashboard",
  components: {
    Loader,
    Pagination
  },
  data() {
    return {
      id: this.$session.get("id"),
      loading: true,
      userData: {},
      certificates: {},
      statsLoaded: false,
      quizzes: {},
      classes: [],
      loadingClasses: true,
      classesLoaded: false,
      limit: 6,
      offset: 0,
      total: 0,
      baseUrl: "courses",
      status: 1
    };
  },

  created() {
    this.getStats();
    this.getFilteredCourses();
    this.getUserProfile();
    this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
    this.offset = this.$route.query.offset
      ? this.$route.query.offset
      : this.offset;
  },
  computed: {
    ...mapGetters({
      userObject: "userObject",
      getUserCourses: "getUserCourses",
      joinedCourse: "getJoinedStatus",
      getLessonId: "getLessonIds"
    })
  },
  methods: {
    ...mapMutations([
      "setJoinedCourse",
      "resetJoinedCourse",
      "setLessonIds",
      "updateUserCourses",
      "setUserCourses"
    ]),

    getUserProfile() {
      this.loadingUser = true;
      getUserProfile(this.id)
        .then(response => {
          if (response.status === 200) {
            this.itemData = response.data.data;
            this.courses = response.data.data.classes;
            this.setUserCourses(this.courses);
            this.bank = response.data.data.bank;
            return true;
          }
          this.userLoaded = false;
          return false;
        })
        .catch(error => {
          this.userLoaded = false;
          return error;
        })
        .finally(() => {
          this.loadingUser = false;
        });
    },
    joinCourse(id) {
      joinCourse(id, { user_id: this.userObject.id })
        .then(response => {
          if (response.status === 201) {
            this.updateUserCourses(response.data);
            this.setJoinedCourse(true);
            success({
              title: "Success! You have successfully joined the course!."
            });
            setTimeout(() => {
              this.$router.push({
                name: "course-detail",
                params: { id }
              });
            }, 2000);
          }
        })
        .catch(error => {
          console.log(error);
          fail({
            title: "Oops! Something went wrong",
            text: error.data
          });
          return error;
        });
    },
    isJoined(id) {
      const status = this.getUserCourses.find(course => course.class_id === id);

      return status ? "Resume Learning" : "Start Learning";
    },
    getFilteredCourses() {
      getFilteredCourses(this.status, this.userObject.career.career_id)
        .then(response => {
          if (response.status === 200) {
            this.classes = response.data.data;
            this.classesLoaded = true;
            return true;
          }
          this.classesLoaded = false;
          return false;
        })
        .catch(error => {
          this.classesLoaded = true;
          return error;
        })
        .finally(() => {
          this.loadingClasses = false;
        });
      return true;
    },

    getStats() {
      const id = this.$session.get("id");
      axios
        .all([getUserProfile(id)])
        .then(
          axios.spread(user => {
            this.userData = user.data.data;

            this.loading = false;
          })
        )
        .catch(error => {
          this.statsLoaded = false;
          this.loading = false;
          return error;
        });
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard__grid__meta {
  font-size: 12px;
  display: flex;
  padding-top: 10px;
  span {
    margin-right: 15px;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.link {
  color: $grey-dark;
  font-weight: normal;
  &:hover {
    color: $green;
  }
}
</style>
